export enum CommsPlanFeatures {
  NONE,
  EXCLUSION_PERIOD,
  INCLUSION_PERIOD,
  INCLUSION_PERMANENT,
  SURVEY_PERIOD,
  SURVEY_PERIOD_ENDING,
  INELIGIBLE
}